// extracted by mini-css-extract-plugin
export default {"button":"IconAction_button__WbZN0","whatsapp":"IconAction_whatsapp__FvcZ6","success":"IconAction_success__-Lp1N","danger":"IconAction_danger__Dwf1O"};